import { createAuthClient } from 'better-auth/vue'
import { emailOTPClient } from 'better-auth/client/plugins'

type ShopAuthClient = ReturnType<typeof createAuthClient>

// Better Auth's useSession() is backed by a per-client reactive store that only
// updates when sign-in/sign-out happens through that same client instance (via its
// internal $sessionSignal). Creating a fresh client per call (as we used to) meant
// signing out through one instance never notified another instance's useSession()
// refs, so the UI kept treating stale, already-signed-out sessions as valid. Caching
// by shopId ensures every caller for a given shop shares the same client/session store.
const clientsByShopId = new Map<string, ShopAuthClient>()

export function createShopAuthClient (shopId: string): ShopAuthClient {
  const existing = clientsByShopId.get(shopId)
  if (existing) {
    return existing
  }
  const client = createAuthClient({
    baseURL: typeof window !== 'undefined' ? `${window.location.origin}/api/auth` : undefined,
    fetchOptions: {
      credentials: 'include',
      headers: {
        'x-johku-shop-id': shopId
      }
    },
    plugins: [
      emailOTPClient()
    ]
  })
  clientsByShopId.set(shopId, client)
  return client
}
